export const useLocaleSwitcher = () => {
  const switchLocalePath = useSwitchLocalePath()
  const { data: eventListPageData } = useEventListPageStore()
  const { data: magazineArticleData } = useMagazineArticleStore()
  const { data: magazineCategoryData } = useMagazineCategoryStore()
  const { origin } = useRequestURL()

  const shouldShowLanguagePicker = computed(() => {
    if (eventListPageData.value) {
      return useEventListPageLocaleSwitcher(
        eventListPageData.value
      ).hasOtherLocales()
    }
    if (magazineArticleData.value) {
      return useMagazineArticleLocaleSwitcher(
        magazineArticleData.value
      ).hasOtherLocales()
    }
    if (magazineCategoryData.value) {
      return useMagazineCategoryLocaleSwitcher(
        magazineCategoryData.value
      ).hasOtherLocales()
    }
    return true
  })

  const getLocaleUrl = (localeCode: string): string => {
    if (eventListPageData.value) {
      const { buildLocaleUrl } = useEventListPageLocaleSwitcher(
        eventListPageData.value
      )
      const customUrl = buildLocaleUrl(localeCode)
      if (customUrl) {
        const path = customUrl.endsWith('/') ? customUrl : customUrl + '/'
        return origin + path
      }
    }

    if (magazineArticleData.value) {
      const { buildLocaleUrl } = useMagazineArticleLocaleSwitcher(
        magazineArticleData.value
      )
      const customUrl = buildLocaleUrl(localeCode)
      if (customUrl) {
        const path = customUrl.endsWith('/') ? customUrl : customUrl + '/'
        return origin + path
      }
    }

    if (magazineCategoryData.value) {
      const { buildLocaleUrl } = useMagazineCategoryLocaleSwitcher(
        magazineCategoryData.value
      )
      const customUrl = buildLocaleUrl(localeCode)
      if (customUrl) {
        const path = customUrl.endsWith('/') ? customUrl : customUrl + '/'
        return origin + path
      }
    }

    const defaultUrl = switchLocalePath(localeCode)
    const path = defaultUrl.endsWith('/') ? defaultUrl : defaultUrl + '/'
    return origin + path
  }

  return {
    shouldShowLanguagePicker,
    getLocaleUrl,
  }
}
